<div class="filters">
  <div class="filter" (clickOutside)="showPartnersFilters = false">
    <div
      (click)="showPartnersFilters = !showPartnersFilters"
      class="filter-button filter-button--partners"
    >
      {{ "brand.campaign.postList.filtersByPartner" | translate }}
      <div class="filter-button__arrow-down"></div>
    </div>
    <div
      class="menu menu--partners partners"
      [ngClass]="{ hidden: !showPartnersFilters }"
    >
      <div class="partners__search">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{
            "brand.campaign.postList.searchByPartnerName" | translate
          }}</mat-label>
          <input
            matInput
            (input)="filterPartners($event.target.value)"
            [(ngModel)]="searchKey"
            name="searchKey"
          />
        </mat-form-field>
        @if (isFiltered) {
          <button
            mat-icon-button
            (click)="clearPartnersFilter(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      @if (partnersPage.length > 0) {
        <div class="partners__select-options">
          <div
            class="partners__select-option"
            (click)="setAllPartnersFilteredChecked(true)"
          >
            {{
              "brand.campaign.postList.checkAll" +
                (isFiltered ? "Filtered" : "") | translate
            }}
          </div>
          <div
            class="partners__select-option"
            (click)="setAllPartnersFilteredChecked(false)"
          >
            {{
              "brand.campaign.postList.unCheckAll" +
                (isFiltered ? "Filtered" : "") | translate
            }}
          </div>
        </div>
      }

      @if (!loading && partnersPage.length === 0) {
        <div class="partners__not-found">
          {{
            (isFiltered
              ? "shared.noPartnersFound"
              : "brand.campaign.postList.filtersNoPartners"
            ) | translate
          }}
        </div>
      }

      <ul class="partners__list">
        @for (partner of partnersPage; track partner.id; let i = $index) {
          <li>
            <mat-checkbox
              name="display{{ partner }}"
              [checked]="partner.checked"
              (change)="togglePartnerFilter(partner)"
            >
              {{ partner.name?.substring(0, 50) }}
            </mat-checkbox>
          </li>
        }
      </ul>

      @if (loading) {
        <div class="partners__loader">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      }

      <mat-paginator
        [length]="totalPartners"
        [pageSize]="LIMIT"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        (page)="onPageChange($event.pageIndex)"
      />
    </div>
  </div>
  <div class="filter" (clickOutside)="showPostTypeFilters = false">
    <div
      class="filter-button filter-button--types"
      (click)="showPostTypeFilters = !showPostTypeFilters"
    >
      {{ "brand.campaign.postList.filtersByContentType" | translate }}
      <div class="filter-button__arrow-down"></div>
    </div>
    <div class="menu" [ngClass]="{ hidden: !showPostTypeFilters }">
      <div class="menu-options">
        <mat-checkbox
          [checked]="displayFacebookPosts"
          (change)="toggleDisplayFacebookPosts()"
        >
          {{ "brand.campaign.postList.filtersFacebookPosts" | translate }}
        </mat-checkbox>
        <mat-checkbox
          [checked]="displayFacebookAds"
          (change)="toggleDisplayFacebookAds()"
        >
          {{ "brand.campaign.postList.filtersFacebookAds" | translate }}
        </mat-checkbox>
        <mat-checkbox
          [checked]="displayGoogleAds"
          (change)="toggleDisplayGoogleAds()"
        >
          {{ "brand.campaign.postList.filtersGoogleAds" | translate }}
        </mat-checkbox>
        <mat-checkbox
          [checked]="displayLinkedInPosts"
          (change)="toggleDisplayLinkedInPosts()"
        >
          {{ "brand.campaign.postList.filtersLinkedInPosts" | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="filter" (clickOutside)="showOrderBy = false">
    <div
      class="filter-button filter-button--order-by"
      (click)="showOrderBy = !showOrderBy"
    >
      {{ "brand.campaign.postList.filtersOrderBy" | translate }}
      <div class="filter-button__arrow-down"></div>
    </div>
    <div class="menu menu--x-before" [ngClass]="{ hidden: !showOrderBy }">
      <mat-radio-group
        class="menu-options"
        [value]="orderBy"
        (change)="setOrderBy($event.value)"
      >
        <mat-radio-button [value]="OrderPostsBy.Date"
          >{{ "brand.campaign.postList.filtersDate" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.AdEngagement"
          >{{ "brand.campaign.postList.filtersAdEngagements" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.AdClicks"
          >{{ "brand.campaign.postList.filtersAdClicks" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.AdImpressions"
          >{{ "brand.campaign.postList.filtersAdImpressions" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.AdReach"
          >{{ "brand.campaign.postList.filtersAdReach" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.PostViews"
          >{{ "brand.campaign.postList.filtersPostViews" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.PostShares"
          >{{ "brand.campaign.postList.filtersPostShares" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.PostComments"
          >{{ "brand.campaign.postList.filtersPostComments" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.PostLikes"
          >{{ "brand.campaign.postList.filtersPostLikes" | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="OrderPostsBy.PostLinkClicks"
          >{{ "brand.campaign.postList.filtersPostClicks" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>
